import request from './request'
import baseUrl from './baseUrl';
const DEBUG_MODE = false
const URL_PREFIX = DEBUG_MODE ? '' : baseUrl;

export function getVersions () {
  return request.get(`${URL_PREFIX}/api/VersionSettings`)
}

//用户协议
export function getUserX () {
  return request.get(`${URL_PREFIX}/api/VersionSettings/3`)
}

//更新用户协议
export function patchUserX (token, data) {
  return request.patch(`${URL_PREFIX}/api/VersionSettings/3?access_token=${token}`, data)
}

//服务条款
export function getService () {
  return request.get(`${URL_PREFIX}/api/VersionSettings/4`)
}

//更新服务条款
export function patchService (token, data) {
  return request.patch(`${URL_PREFIX}/api/VersionSettings/4?access_token=${token}`, data)
}

//租赁协议
export function getRentXie () {
  return request.get(`${URL_PREFIX}/api/VersionSettings/5`)
}

//更新租赁协议
export function patchRentXie (token, data) {
  return request.patch(`${URL_PREFIX}/api/VersionSettings/5?access_token=${token}`, data)
}

//租赁规则
export function getRentRule (id) {
  return request.get(`${URL_PREFIX}/api/VersionSettings/${id}`)
}

//新增租赁规则
export function addRentRule (id, token, data) {
  return request.patch(`${URL_PREFIX}/api/VersionSettings/${id}?access_token=${token}`, data)
}

//帮助中心
export function getHelp (id) {
  return request.get(`${URL_PREFIX}/api/VersionSettings/${id}`)
}

//更新帮助中心
export function patchHelp (id, token, data) {
  return request.patch(`${URL_PREFIX}/api/VersionSettings/${id}?access_token=${token}`, data)
}

export function getBanner (data) {
  return request.get(`${URL_PREFIX}/api/VersionSettings?filter=${data}`)
}



export function putBanner (token,id,data) {
  return request.put(`${URL_PREFIX}/api/VersionSettings/${id}?access_token=${token}`, data)
}

export function postVersions (token,data) {
  return request.post(`${URL_PREFIX}/api/VersionSettings?access_token=`+token, data)
}

export function patchVersions (token,data) {
  return request.patch(`${URL_PREFIX}/api/VersionSettings?access_token=`+token, data)
}

export function patchVersionsId (token,id,data) {
  return request.patch(`${URL_PREFIX}/api/VersionSettings/${id}?access_token=`+token, data)
}

export function putVersions (token,id,data) {
  return request.put(`${URL_PREFIX}/api/VersionSettings/${id}?access_token=${token}`, data)
}

export function deleteVersions (token,data) {
  return request.delete(`${URL_PREFIX}/api/VersionSettings/`+ data +'?access_token='+token )
}

export function filterIndexVersions () {
  return request.get(`${URL_PREFIX}/api/VersionSettings?filter=%7B%22where%22%3A%7B%22version%22%3A%7B%22like%22%3A%20%22index%25%22%7D%7D%7D`)
}

export function getGlobalSettings () {
  return request.get(`${URL_PREFIX}/api/GlobalSettings`)
}

export function putGlobalSettings (token, data) {
  return request.put(`${URL_PREFIX}/api/GlobalSettings?access_token=${token}`, data)
}

export function patchGlobalSettings (token, data) {
  return request.patch(`${URL_PREFIX}/api/GlobalSettings?access_token=${token}`, data)
}

//获取商品分类
export function getProductCategories () {
  return request.get(`${URL_PREFIX}/api/ProductCategories`)
}

//添加商品分类
export function putProductCategories (token, data) {
  return request.put(`${URL_PREFIX}/api/ProductCategories?access_token=${token}`,data)
}

//更新商品分类
export function patchProductCategories (id,token,data) {
  return request.patch(`${URL_PREFIX}/api/ProductCategories/${id}?access_token=${token}`,data)
}

//删除商品分类
export function deleteProductCategories (id,token,data) {
  return request.delete(`${URL_PREFIX}/api/ProductCategories/${id}?access_token=${token}`,data)
}


//获取商品标签
export function getProductTags () {
  return request.get(`${URL_PREFIX}/api/ProductTags`)
}

//添加商品标签
export function postProductTags (token, data) {
  return request.post(`${URL_PREFIX}/api/ProductTags?access_token=${token}`,data)
}

//更新商品标签
export function patchProductTags  (id,token,data) {
  return request.patch(`${URL_PREFIX}/api/ProductTags/${id}?access_token=${token}`,data)
}

//删除商品标签
export function deleteProductTags (id,token,data) {
  return request.delete(`${URL_PREFIX}/api/ProductTags/${id}?access_token=${token}`,data)
}

//获取商品
export function getProductDetails () {
  return request.get(`${URL_PREFIX}/api/ProductDetails`)
}

//获取商品，除了选配商品
export function getProductDetailsOnly (token,data) {
  return request.get(`${URL_PREFIX}/api/ProductDetails?access_token=${token}&filter=${data}`)
}

//新增商品
export function addProductDetails (token, data) {
  return request.post(`${URL_PREFIX}/api/ProductDetails?access_token=${token}`, data)
}

//更新商品
export function putProductDetails (token, id, data) {
  return request.put(`${URL_PREFIX}/api/ProductDetails/${id}?access_token=${token}`, data)
}

//更新商品
export function patchProductDetails (token, id, data) {
  return request.patch(`${URL_PREFIX}/api/ProductDetails/${id}?access_token=${token}`, data)
}

//获取某一个商品
export function getProductDetailsId (id) {
  return request.get(`${URL_PREFIX}/api/ProductDetails/${id}`)
}

//更新某一个商品
export function putProductDetailsId (id,token, data) {
  return request.put(`${URL_PREFIX}/api/ProductDetails/${id}?access_token=${token}`,data)
}

//搜索商品
export function filterProductDetails (data) {
  return request.get(`${URL_PREFIX}/api/ProductDetails?filter=${data}`)
}

//搜索商品
export function filterUser (token,data) {
  return request.get(`${URL_PREFIX}/api/UserManages?access_token=${token}&filter=${data}`)
}

//搜索仓库
export function filterStorages (token,data) {
  return request.get(`${URL_PREFIX}/api/Storages?access_token=${token}&filter=${data}`)
}

//获取选配列表
export function getProductAccessories (token, data) {
  return request.get(`${URL_PREFIX}/api/ProductDetails?access_token=${token}&filter=${data}`)
}

//获取某个商品的选配列表
export function getProductAccessoriesDetailId (token, data) {
  return request.get(`${URL_PREFIX}/api/ProductAccessories?access_token=${token}&filter=${data}`)
}

//选配与商品绑定
export function postProductAccessories (token, data) {
  return request.post(`${URL_PREFIX}/api/ProductAccessories?access_token=${token}`,data)
}

//删除选配与商品绑定
export function deleteProductAccessories (token, id) {
  return request.delete(`${URL_PREFIX}/api/ProductAccessories/${id}?access_token=${token}`)
}

//获取某一个商品的选配
export function getProductAccessoriesId (token, id) {
  return request.get(`${URL_PREFIX}/api/ProductDetails/${id}/accessory?access_token=${token}`)
}

//获取设备列表
export function getProducts (token, filter) {
  return request.get(`${URL_PREFIX}/api/Products?access_token=${token}&filter=${filter}`)
}

//更新设备
export function patchProducts (token, id, data) {
  return request.patch(`${URL_PREFIX}/api/Products/${id}?access_token=${token}`, data)
}

//仓库拥有的设备数量
export function getStorageCount (token, filter) {
  return request.get(`${URL_PREFIX}/api/Products/count?access_token=${token}&where=${filter}`)
}

//获取某一个设备
export function getProductsId (token,id) {
  return request.get(`${URL_PREFIX}/api/Products/${id}?access_token=${token}`)
}

//获取某一个设备
export function getProductsIds (token, id) {
  return request.get(`${URL_PREFIX}/api/Products/${id}?access_token=${token}`)
}

//更新某一个设备
export function patchProductsIds (token, id, data) {
  return request.patch(`${URL_PREFIX}/api/Products/${id}?access_token=${token}`, data)
}

//删除设备
export function deleteProducts (id) {
  return request.delete(`${URL_PREFIX}/api/Products/${id}`)
}

//添加设备列表
export function postProducts (token,data) {
  return request.post(`${URL_PREFIX}/api/Products?access_token=${token}`,data)
}

//订单完成
export function finishOrder (token,id,data) {
  return request.post(`${URL_PREFIX}/api/Orders/${id}/finish?access_token=${token}`,data)
}

//更新设备列表
export function putProducts (token,id,data) {
  return request.put(`${URL_PREFIX}/api/Products/${id}?access_token=${token}`,data)
}

//删除设备
export function deleteProductsOne (token,id) {
  return request.delete(`${URL_PREFIX}/api/Products/${id}?access_token=${token}`)
}

//获取仓库数据
export function getStorages (token) {
  return request.get(`${URL_PREFIX}/api/Storages?access_token=${token}`)
}

//获取仓库数据
export function getStoragesId (token,id) {
  return request.get(`${URL_PREFIX}/api/Storages/${id}?access_token=${token}`)
}

//新增仓库数据
export function postStorages (token, data) {
  return request.post(`${URL_PREFIX}/api/Storages?access_token=${token}`, data)
}

//更新仓库数据
export function patchStorages (token, id, data) {
  return request.patch(`${URL_PREFIX}/api/Storages/${id}?access_token=${token}`, data)
}

//删除仓库数据
export function deleteStorages (token, id) {
  return request.delete(`${URL_PREFIX}/api/Storages/${id}?access_token=${token}`)
}

//获取选配列表
export function getAccessory (token,data) {
  return request.get(`${URL_PREFIX}/api/ProductDetails?access_token=${token}&filter=${data}`)
}

//添加选配
export function addAccessory (token, data) {
  return request.post(`${URL_PREFIX}/api/ProductDetails?access_token=${token}`,data)
}

//删除选配
export function removeAccessory (token, id) {
  return request.delete(`${URL_PREFIX}/api/ProductDetails/${id}?access_token=${token}`)
}

//删除商品
export function removeProduct (token,id) {
  return request.delete(`${URL_PREFIX}/api/ProductDetails/${id}?access_token=${token}`)
}

//商品和标签关联
export function postProductTag (token, data) {
  return request.post(`${URL_PREFIX}/api/ProductTagDetails?access_token=${token}`,data)
}

//删除商品和标签关联
export function deleteProductTag (token, id) {
  return request.delete(`${URL_PREFIX}/api/ProductTagDetails/${id}?access_token=${token}`)
}

// 获取某个商品的商品标签
export function getProductTagId (token, id) {
  return request.get(`${URL_PREFIX}/api/ProductDetails/${id}/tag?access_token=${token}`)
}

// 获取某个商品的商品标签 new
export function getProductTagAll (token, data) {
  return request.get(`${URL_PREFIX}/api/ProductTagDetails?access_token=${token}&filter=${data}`)
}

//获取用户列表
export function getUsers (token,filter) {
  return request.get(`${URL_PREFIX}/api/UserManages?access_token=${token}&filter=${filter}`)
}

//获取某一个用户信息
export function getUsersDetail (token,id) {
  return request.get(`${URL_PREFIX}/api/UserManages/${id}?access_token=${token}`)
}

//修改密码
export function patchUsersPsd (token, id, data) {
  return request.patch(`${URL_PREFIX}/api/UserManages/${id}?access_token=${token}`,data)
}

//获取某个用户身份证信息
export function getUserIdentification (token,id) {
  return request.get(`${URL_PREFIX}/api/UserManages/${id}/userIdentification?access_token=${token}`)
}

//获取某个用户默认地址
export function getDefaultAddress (token,id) {
  return request.get(`${URL_PREFIX}/api/UserManages/${id}/defaultAddress?access_token=${token}`)
}

//获取某个用户订单
export function getUserOrder (token,id,filter) {
  return request.get(`${URL_PREFIX}/api/UserManages/${id}/orders?access_token=${token}&filter=${filter}`)
}

//获取某一个订单
export function getOrderId (token,id) {
  return request.get(`${URL_PREFIX}/api/Orders/${id}?access_token=${token}`)
}

//删除用户
export function deleteUser (token,id) {
  return request.delete(`${URL_PREFIX}/api/UserManages/${id}?access_token=${token}`)
}

//用户实名认证
export function getIdentification (token,data) {
  return request.get(`${URL_PREFIX}/api/UserIdentifications?access_token=${token}&filter=${data}`)
}

//获取某一个用户实名认证
export function getIdentificationId (token,id) {
  return request.get(`${URL_PREFIX}/api/UserIdentifications/${id}?access_token=${token}`)
}

//跟新某一个用户实名认证
export function putUserManage(token,id,data) {
  return request.post(`${URL_PREFIX}/api/UserManages/${id}/identify?access_token=${token}`,data)
}

//获取订单列表
export function getOrder (token, filter) {
  return request.get(`${URL_PREFIX}/api/Orders?access_token=${token}&filter=${filter}`)
}

//获取订单总数
export function getOrderCount(token,filter) {
  return request.get(`${URL_PREFIX}/api/Orders/count?access_token=${token}&where=${filter}`)
}

//获取设备总数
export function getProductCount(token,filter) {
  return request.get(`${URL_PREFIX}/api/Products/count?access_token=${token}&where=${filter}`)
}

//获取设备总数
export function getProductdetailsCount(token,filter) {
  return request.get(`${URL_PREFIX}/api/ProductDetails/count?access_token=${token}&where=${filter}`)
}

//获取商品总数
export function getProductdetailCount(token,filter) {
  return request.get(`${URL_PREFIX}/api/ProductDetails/count?access_token=${token}&where=${filter}`)
}

//获取用户总数
export function getUserCount(token,filter) {
  return request.get(`${URL_PREFIX}/api/UserManages/count?access_token=${token}&where=${filter}`)
}

//获取反馈列表总数
export function getFeedCount(token,filter) {
  return request.get(`${URL_PREFIX}/api/Feedbacks/count?access_token=${token}&where=${filter}`)
}

//获取评论列表总数
export function getCommontCount(token,filter) {
  return request.get(`${URL_PREFIX}/api/Comments/count?access_token=${token}&where=${filter}`)
}

//修改订单物流信息
export function putExpress(token,id) {
  return request.put(`${URL_PREFIX}/api/Orders/${id}/received?access_token=${token}`)
}

//发货
export function sendExpress(token,id,data) {
  return request.put(`${URL_PREFIX}/api/Orders/${id}/deliver?access_token=${token}`, data)
}

//更新芝麻信用
export function updateZM(token,id,data) {
  return request.put(`${URL_PREFIX}/api/UserManages/${id}/updateZM?access_token=${token}`)
}

//删除订单
export function deleteOrder(token,id) {
  return request.post(`${URL_PREFIX}/api/Orders/${id}/del?access_token=${token}`)
}

//取消订单
export function cancelOrder(token,id) {
  return request.get(`${URL_PREFIX}/api/Orders/${id}/cancel?access_token=${token}`)
}

export function alipayMiniCancelOrder(token,id) {
  return request.get(`${URL_PREFIX}/api/Orders/${id}/alipayMiniCancel?access_token=${token}&reason='用户沟通取消'`)
}

//订单返还
export function backOrder(token,id,data) {
  return request.put(`${URL_PREFIX}/api/Orders/${id}/return?access_token=${token}`, data)
}

//获取仓库列表
export function getStoragesList (token) {
  return request.get(`${URL_PREFIX}/api/Storages?access_token=${token}`)
}

//获取评论列表GET /Comments
export function getComments (token,filter) {
  return request.get(`${URL_PREFIX}/api/Comments?access_token=${token}&filter=${filter}`)
}

//筛选评论列表GET /Comments
export function filterComments (token, data) {
  return request.get(`${URL_PREFIX}/api/Comments?access_token=${token}&filter=${data}`)
}

//审核评论
export function putComments (token, id, data) {
  return request.patch(`${URL_PREFIX}/api/Comments/${id}?access_token=${token}`, data)
}

//删除评论
export function deleteComments (token, id) {
  return request.delete(`${URL_PREFIX}/api/Comments/${id}?access_token=${token}`)
}

//获取某一个订单
export function getOrderDetail (token, id) {
  return request.get(`${URL_PREFIX}/api/Orders/${id}?access_token=${token}`)
}

//意见反馈列表
export function getFeedBack (token,filter) {
  return request.get(`${URL_PREFIX}/api/Feedbacks?access_token=${token}&filter=${filter}`)
}

//更新反馈列表
export function patchFeedBack (token,id,data) {
  return request.patch(`${URL_PREFIX}/api/Feedbacks/${id}?access_token=${token}`, data)
}

//删除反馈列表
export function deleteFeedBack (token,id) {
  return request.delete(`${URL_PREFIX}/api/Feedbacks/${id}?access_token=${token}`)
}

//获取物流信息
export function getExpress (token,data) {
  return request.get(`${URL_PREFIX}/api/ExpressStatuses?access_token=${token}&filter=${data}`)
}

//获取物流信息
export function getExpressD (token,express,shipper) {
  return request.get(`${URL_PREFIX}/api/ExpressStatuses/syncStatus?access_token=${token}&expressNum=${express}&shipper=${shipper}`)
}

//热门搜索
export function getHot (token) {
  return request.get(`${URL_PREFIX}/api/GlobalSettings/search_words?access_token=${token}`)
}

//更新热门搜索
export function patchHot (token,data) {
  return request.patch(`${URL_PREFIX}/api/GlobalSettings/search_words?access_token=${token}`,data)
}
//查看租赁历史
export function getRentHistory (token,id) {
  return request.get(`${URL_PREFIX}/api/Products/${id}/showHistory?access_token=${token}`)
}

export function getAccount (token,filter) {
  return request.get(`${URL_PREFIX}/api/AdminUsers?access_token=${token}&filter=${filter}`)
}

export function deleteAccount (token,id) {
  return request.delete(`${URL_PREFIX}/api/AdminUsers/${id}?access_token=${token}`)
}

export function patchPsd (token,id,data) {
  return request.patch(`${URL_PREFIX}/api/AdminUsers/${id}?access_token=${token}`, data)
}

export function getAccountId (token,id) {
  return request.get(`${URL_PREFIX}/api/AdminUsers/${id}?access_token=${token}`)
}

export function addAccount (token, data) {
  return request.post(`${URL_PREFIX}/api/AdminUsers?access_token=${token}`, data)
}

export function changeBackExpress (token, id, data) {
  return request.post(`${URL_PREFIX}/api/Orders/${id}/setReturnExpress?access_token=${token}`, data)
}

export function patchAccount (token, id,data) {
  return request.patch(`${URL_PREFIX}/api/AdminUsers/${id}?access_token=${token}`, data)
}

export function getMount (token,id,begin,end) {
  return request.get(`${URL_PREFIX}/api/ProductDetails/${id}/amount?access_token=${token}&begin=${begin}&end=${end}`)
}


export function getProductRent (token,data) {
  return request.get(`${URL_PREFIX}/api/ProductRentLogs?access_token=${token}&filter=${data}`)
}

export function getTongji (token) {
  return request.get(`${URL_PREFIX}/api/AdminUsers/getStatistics?access_token=${token}`)
}

export function getFreashOrder (token) {
  return request.get(`${URL_PREFIX}/api/AdminUsers/updateOrderSum?access_token=${token}`)
}


export function putProduct (token, id) {
  return request.put(`${URL_PREFIX}/api/ProductDetails/${id}/updateRentalSum?access_token=${token}`)
}

export function zmRefundOrder(orderId, token) {
    return request.get(`${URL_PREFIX}/api/ZmRefundOrders/refundDone?orderId=${orderId}&access_token=${token}`)
}

export function doInstallment(orderId, token) {
    return request.get(`${URL_PREFIX}/api/ZmInstallments/doInstallment?orderId=${orderId}&access_token=${token}`)
}



// WEBPACK FOOTER //
// ./src/api/version.js